module.exports = __webpack_public_path__ + "static/media/bus.07bbe940.png";